import { api } from 'api/axios';
import { useMutation } from '@tanstack/react-query';

const loginUserByFacebook= (url,data) => 
{
    console.log("URL" + JSON.stringify(url));
    return api.post(url, data);
}

export const useLoginUserByFacebook = (options = {}) => 
  useMutation({
    mutationFn: (data) => loginUserByFacebook(options.url,data),
    ...options,
  });
